export const GET_ALL_AUCTION_GAMES = "GET_ALL_AUCTION_GAMES";
export const ITEM_SEARCH_VALUE = "ITEM_SEARCH_VALUE";
export const CATEGORY_SEARCH_VALUE = "CATEGORY_SEARCH_VALUE";
export const ENTER_KEY_VAL = "ENTER_KEY_VAL";
export const GET_ALL_SELL_ITEMS = "GET_ALL_SELL_ITEMS";
export const GET_ALL_WATCH_LISTS = "GET_ALL_WATCH_LISTS";
export const GET_ALL_ENDING_AUCTIONS = "GET_ALL_ENDING_AUCTIONS";
export const GET_TOTAL_ENDING = "GET_TOTAL_ENDING";
export const GET_ALL_NEW_AUCTIONS = "GET_ALL_NEW_AUCTIONS";
export const GET_ALL_COMING_SOON_AUCTIONS = "GET_ALL_COMING_SOON_AUCTIONS";
export const GET_ALL_RESERVED_AUCTIONS = "GET_ALL_RESERVED_AUCTIONS";
export const GET_ALL_FEATURED_AUCTIONS = "GET_ALL_FEATURED_AUCTIONS";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_ALL_USER_BIDS = "GET_ALL_USER_BIDS";
export const GET_ALL_SOLD_ITEMS = "GET_ALL_SOLD_ITEMS";
export const GET_GAME_DETAIL = "GET_GAME_DETAIL";
export const EDIT_ITEM_DEATIL = "EDIT_ITEM_DEATIL";
export const GET_ALL_SEARCHED_CATEGORY = "GET_ALL_SEARCHED_CATEGORY";
export const EDIT_ITEM_VALUE = "EDIT_ITEM_VALUE";
export const GO_TO_SELL_ITEM = "GO_TO_SELL_ITEM";
export const RESET_TIME = "RESET_TIME";
export const GET_ALL_COMPLETED_AUCTIONS = "GET_ALL_COMPLETED_AUCTIONS";
export const GET_CLOSEST_TOTAL = "GET_CLOSEST_TOTAL";
export const LOST_DATA = "LOST_DATA";
export const GET_CURRENT_BID_AUCTIONS = "GET_CURRENT_BID_AUCTIONS";
export const USER_SAVED_SEARCHES = "USER_SAVED_SEARCHES";
export const USER_DISPUTES = "USER_DISPUTES";
export const USER_SHIPPING_ADDRESSES = "USER_SHIPPING_ADDRESSES";
export const USER_DELIVERY_STATUS = "USER_DELIVERY_STATUS";
export const GET_AUCTION_SEARCH_NAMES = "GET_AUCTION_SEARCH_NAMES";
export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const DELETE_AUCTION_SUCCESS = "DELETE_AUCTION_SUCCESS";
export const UPDATE_LISTED_AUCTION_ITEM = "UPDATE_LISTED_AUCTION_ITEM";
export const UPDATE_SOLD_ITEM = "UPDATE_SOLD_ITEM";
export const UPDATE_MANAGED_BID_ITEM = "UPDATE_MANAGED_BID_ITEM";
export const UPDATE_WON_AUCTION_ITEM = "UPDATE_WON_AUCTION_ITEM";

export const FETCH_USER_MANAGED_BIDS_LOADING =
  "FETCH_USER_MANAGED_BIDS_LOADING";
export const FETCH_USER_MANAGED_BIDS_SUCCESS =
  "FETCH_USER_MANAGED_BIDS_SUCCESS";
export const FETCH_USER_MANAGED_BIDS_ERROR = "FETCH_USER_MANAGED_BIDS_ERROR";
export const SET_MANAGED_BIDS_FILTER = "SET_MANAGED_BIDS_FILTER";
export const RESET_MANAGED_BIDS_FILTERS = "RESET_MANAGED_BIDS_FILTERS";

export const AUCTION_SUBMITED = "AUCTION_SUBMITED";

// For WebSocket updates to these managed bids
export const WS_UPDATE_MY_BID_STATUS_MANAGED =
  "WS_UPDATE_MY_BID_STATUS_MANAGED";
export const WS_USER_WAS_OUTBID_MANAGED = "WS_USER_WAS_OUTBID_MANAGED";
export const WS_TRACKED_AUCTION_ENDED_MANAGED =
  "WS_TRACKED_AUCTION_ENDED_MANAGED";

export const FETCH_USER_WON_AUCTIONS_LOADING =
  "FETCH_USER_WON_AUCTIONS_LOADING";
export const FETCH_USER_WON_AUCTIONS_SUCCESS =
  "FETCH_USER_WON_AUCTIONS_SUCCESS";
export const FETCH_USER_WON_AUCTIONS_ERROR = "FETCH_USER_WON_AUCTIONS_ERROR";

export const WS_UPDATE_WON_AUCTION_STATUS = "WS_UPDATE_WON_AUCTION_STATUS";
export const WS_ADD_NEWLY_WON_AUCTION = "WS_ADD_NEWLY_WON_AUCTION";

export const FETCH_USER_LISTED_AUCTIONS_LOADING =
  "FETCH_USER_LISTED_AUCTIONS_LOADING";
export const FETCH_USER_LISTED_AUCTIONS_SUCCESS =
  "FETCH_USER_LISTED_AUCTIONS_SUCCESS";
export const FETCH_USER_LISTED_AUCTIONS_ERROR =
  "FETCH_USER_LISTED_AUCTIONS_ERROR";
export const SET_LISTED_AUCTIONS_FILTER = "SET_LISTED_AUCTIONS_FILTER";
export const RESET_LISTED_AUCTIONS_FILTERS = "RESET_LISTED_AUCTIONS_FILTERS";
export const SET_AUCTION_VIEWS = "SET_AUCTION_VIEWS";

// HOME CROUSAL DATA
export const GET_HANDLE_HOME_SLIDE = "GET_HANDLE_HOME_SLIDE";

// cms content

// FOOTER NEWSLETTER DATA
export const GET_HANDLE_FOOTER_NEWSLETTER = "GET_HANDLE_FOOTER_NEWSLETTER";

// BID ONGOING
export const GET_MY_BID_ONGOING = "GET_MY_BID_ONGOING";

//.NEW GET SELER AUCTION
export const GET_ALL_SELLER_AUCTIONS = "GET_ALL_SELLER_AUCTIONS";
export const GET_ALL_MY_AUCTIONS = "GET_ALL_MY_AUCTIONS";
export const GET_MY_AUCTION_DETAIL = "GET_MY_AUCTION_DETAIL";
export const GET_ALL_MY_ORDER = "GET_ALL_MY_ORDER";
export const GET_MY_ORDER_DETAIL = "GET_MY_ORDER_DETAIL";
export const GET_ALL_MY_SOLDITEM = "GET_ALL_MY_SOLDITEM";
export const GET_ON_AUCTION = "GET_ON_AUCTION";
export const GET_WON_BIDMANAGEMENT = "GET_WON_BIDMANAGEMENT";
export const GET_LOST_BIDMANAGEMENT = "GET_LOST_BIDMANAGEMENT";
export const GET_ALL_BIDMANAGEMENT = "GET_ALL_BIDMANAGEMENT";
export const GET_ONGOING_BIDMANAGEMENT = "GET_ONGOING_BIDMANAGEMENT";
export const GET_IS_AUCTION = "GET_IS_AUCTION";
export const GET_SELLER_DETAIL = "GET_SELLER_DETAIL";

export const GET_ALL_NEW_NOTIFICATIONS = "GET_ALL_NEW_NOTIFICATIONS";
export const GET_ALL_SHIPPING_METHOD = "GET_ALL_SHIPPING_METHOD";

export const GET_TRACK_STATUS = "GET_TRACK_STATUS";

//FOR Stox ALL CATEGORIES
export const GET_MY_EDIT_AUCTION_DETAIL = "GET_MY_EDIT_AUCTION_DETAIL";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SEARCHSUGGESTIONS = "GET_SEARCHSUGGESTIONS";
export const GET_SEARCHVALUES = "GET_SEARCHVALUES";
export const GET_SEARCH_TOTAL = "GET_SEARCH_TOTAL";
export const GET_BRANDS = "GET_BRANDS";
export const GET_MASTER_PRODUCTS = "GET_MASTER_PRODUCTS";
export const GET_VARIANTS_PRODUCTS = "GET_VARIANTS_PRODUCTS";
export const GET_CART_ITEMS = "GET_CART_ITEMS";
export const ADD_ = "GET_CART_ITEMS";

export const GET_SELLER_COUNTRIES_OF_ORIGIN = "GET_SELLER_COUNTRIES_OF_ORIGIN";
export const GET_SELLER_GENDERS = "GET_SELLER_GENDERS";
export const GET_SELLER_SEASONS = "GET_SELLER_SEASONS";
export const GET_SELLER_MATERIALS = "GET_SELLER_MATERIALS";
export const GET_SELLER_MODELS = "GET_SELLER_MODELS";
export const GET_SELLER_PRODUCT_SUBTYPE = "GET_SELLER_PRODUCT_SUBTYPE";

export const GET_PRODUCT_SIZES = "GET_PRODUCT_SIZES";
export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";


